import {
  ButtonGroup,
  Flex,
  Grid,
  Icon,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { FaUserCheck, FaUserPlus } from 'react-icons/fa';
import { CheckTree } from 'rsuite';
import styled from 'styled-components';
import { BlgModalSonarPlusFinish } from './ModalSonarPlusFinish';
import BlgSelect from '../Select';
import BlgInput from '../Input';
import BlgButton from '../Button/Button';
import { useConnections } from '../../api';
import { useRole } from '../../hooks';

interface PickerOption {
  label: string;
  value: string;
  selected?: boolean;
  children?: PickerOption[];
}
export interface iModalEpisode {
  episode: any;
  isOpen: boolean;
  onClose: () => void;
}

const optionsExample = [
  {
    id: 'all',
    label: 'All',
    value: 'all',
  },
  {
    id: 'students',
    label: 'Students',
    value: 'students',
  },
  {
    id: 'teachers',
    label: 'Teachers',
    value: 'teachers',
  },
];
const CheckTreeStyled = styled.div`
  .rs-check-tree {
    background: none;
  }
  .rs-check-tree-node
    > .rs-check-tree-node-label
    .rs-check-item
    .rs-checkbox-checker
    > label::before {
    background: none;
  }
  *::-webkit-scrollbar {
    width: 12px; /* width of the entire scrollbar */
  }

  *::-webkit-scrollbar-track {
    background: none; /* color of the tracking area */
  }

  *::-webkit-scrollbar-thumb {
    background-color: gray; /* color of the scroll thumb */
    border-radius: 20px; /* roundness of the scroll thumb */
    border: 3px solid transparent; /* creates padding around scroll thumb */
  }
`;
export const BlgModalSonarPlus = ({
  episode,
  isOpen,
  onClose,
}: iModalEpisode) => {
  const {
    isOpen: isOpenCreate,
    onOpen: onOpenCreate,
    onClose: onCloseCreate,
  } = useDisclosure();
  const { userRole } = useRole();
  const { isTeacher = false, isAdmin = false } = userRole || {};
  const { data: { connections, classrooms } = {} } = useConnections();

  const [pickerList, setPickerList] = useState<PickerOption[]>([]);
  const [selectedPicks, setSelectedPicks] = useState<string[]>([]);

  const handlePickerChange = (values: string[]) => {
    const newPicks = values;
    const selectedClassrooms = values.filter(
      (id) => id.indexOf('ind__') === -1 && id.indexOf('class__') === -1
    );
    if (!!selectedClassrooms?.length) {
      selectedClassrooms.forEach((parentClassroomId) => {
        const classroomStudents: string[] = [];
        const classroom =
          pickerList[1]?.children &&
          pickerList[1].children.find(
            ({ value }) => value === parentClassroomId
          );
        if (classroom?.children) {
          classroom.children.forEach((student) => {
            classroomStudents.push(student.value);
          });
          newPicks.push(...classroomStudents);
        }
      });
    }
    setSelectedPicks([...Array.from(new Set(newPicks))]);
  };
  const resetPickerOptions = () => {
    const options = [];
    if (connections && !!connections.active.length) {
      options.push({
        label: 'My Belouga Connections',
        value: '1',
        children: connections.active.map((u: any) => {
          return {
            label:
              isTeacher || isAdmin
                ? `${u.first_name} ${u.last_name} (${u.username})`
                : u.username,
            value: `ind__${u.id}`,
          };
        }),
      });
    }
    if (classrooms && isTeacher) {
      const classroomIds = Object.keys(classrooms);
      options.push({
        label: 'My Classrooms',
        value: '2',
        children: classroomIds.map((classroomId) => {
          const { classroom, users } = classrooms[classroomId];
          const classroomChildren = users.map((u: any) => {
            return {
              label: u.username,
              value: `class__${u.id}`,
            };
          });
          return {
            label: classroom.name,
            value: classroom.id,
            children: classroomChildren,
          };
        }),
      });
    }
    setPickerList([...options]);
  };

  useEffect(() => {
    if (classrooms || connections) {
      resetPickerOptions();
    }
  }, [connections]);

  // console.log(pickerList);

  const [select, setSelect] = useState('add');
  const [search, setSearch] = useState('');

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="4xl" isCentered>
        <ModalOverlay />
        <ModalContent borderRadius={18} bg="white" overflow="hidden" h={700}>
          <ModalCloseButton />
          <ModalBody p={0}>
            <Grid templateColumns="1fr 1fr" h="full">
              <Flex bgImage={episode.image} backgroundSize="cover">
                <Flex
                  bg="blackAlpha.700"
                  flexDir="column"
                  justifyContent="center"
                  alignItems="center"
                  gap={2}
                  w="full"
                >
                  <Text
                    color="white"
                    fontSize={28}
                    fontWeight={700}
                    textAlign="center"
                    p={6}
                  >
                    {episode.title}
                  </Text>
                </Flex>
              </Flex>

              <Flex flexDir="column">
                <Flex bg="darkBlue.500" flexDir="column" gap={1} p={8}>
                  <Text color="white" fontWeight={700}>
                    Sonar
                  </Text>
                  <Text color="white" fontWeight={400} fontSize={12}>
                    Invite your connections on Belouga to team together{' '}
                  </Text>
                </Flex>

                <Flex alignItems="start">
                  <Flex flexDir="column" p={6} w="full">
                    {/* <ButtonGroup w="full" isAttached variant="outline" mb={4}>
                      <BlgButton
                        w="full"
                        colorScheme="darkBlue"
                        borderColor="gray.500"
                        onClick={() => setSelect('add')}
                        color={select === 'add' ? 'darkBlue.500' : 'gray.500'}
                      >
                        <Icon as={FaUserPlus} mr={2} />
                      </BlgButton>
                      <BlgButton
                        w="full"
                        colorScheme="darkBlue"
                        borderColor="gray.500"
                        onClick={() => setSelect('check')}
                        color={select === 'check' ? 'darkBlue.500' : 'gray.500'}
                      >
                        <Icon as={FaUserCheck} mr={2} />
                      </BlgButton>
                    </ButtonGroup> */}
                    <BlgSelect
                      shadow="sm"
                      size="lg"
                      options={optionsExample}
                      isDisabled
                    />
                    <Flex
                      flexDir="column"
                      bg="gray.50"
                      p={4}
                      pt={10}
                      mt={-6}
                      borderRadius="0px 0px 18px 18px"
                      shadow="md"
                      gap={2}
                      w="full"
                    >
                      <BlgInput
                        placeholder="Search"
                        mb={4}
                        shadow="sm"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />

                      <Flex flexDir="column" gap={1} maxH={300}>
                        <CheckTreeStyled>
                          <CheckTree
                            height={250}
                            data={pickerList}
                            uncheckableItemValues={['1', '2']}
                            onChange={handlePickerChange}
                            cascade
                            searchKeyword={search}
                          />
                        </CheckTreeStyled>
                      </Flex>
                    </Flex>
                    <BlgButton
                      mt={4}
                      w="full"
                      colorScheme="newGreen"
                      shadow="md"
                      onClick={onOpenCreate}
                    >
                      Create
                    </BlgButton>
                  </Flex>
                </Flex>
              </Flex>
            </Grid>
          </ModalBody>
        </ModalContent>
        {isOpenCreate && (
          <BlgModalSonarPlusFinish
            isOpen={isOpenCreate}
            onClose={onCloseCreate}
            selectedPicks={selectedPicks}
            episodeId={episode.id}
            resetPickerOptions={resetPickerOptions}
          />
        )}
      </Modal>
    </>
  );
};
